/**
 * Note: Роутинг для раздела "тренажер"
 */

import auth from '@/router/_middleware/auth'

export default [
  {
    component: () => import('@/views/master/training/Item.vue'),
    meta: { middleware: [auth] },
    name: 'master.training.item',
    path: '/master/training/question/:questionID',
  },
  {
    component: () => import('@/views/master/training/Favorites.vue'),
    meta: { middleware: [auth] },
    name: 'master.training.favorites',
    path: '/master/training/favorites',
  },
  {
    component: () => import('@/views/master/training/List.vue'),
    meta: { middleware: [auth] },
    name: 'master.training.subject',
    path: '/master/training/:subject',
  },
  {
    component: () => import('@/views/master/training/Training.vue'),
    meta: { middleware: [auth] },
    name: 'master.training',
    path: '/master/training',
  },
]
